import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/CustomerCreditLimitReport/ARReportCustomerCreditLimitAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ARReportCustomerCreditLimitActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/CustomerCreditLimitReport/ARReportCustomerCreditLimit")
	}

	render() {
		return (
			<Activity 
				name="ARReportCustomerCreditLimit"
				RenderedComponent={this.RenderedComponent}
				context="ARReportCustomerCreditLimit"
				action="ARReportCustomerCreditLimit"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ARReportCustomerCreditLimitActivity)
